import CenteredHero from "@/components/CenteredHero"
import GeneralLayout from "@/layouts/General"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import EngraveTitle from "../../di-sana/components/EngraveTitle"
import ContentMAPI from "@/app/api/content-management/content-management"
import { useEffect, useRef, useState } from "react"
import { useGlobalContext } from "@/global/GlobalContext"
import { useParams } from "react-router-dom"
import EventCardSkeleton from "@/components/skeletons/EventCardSkeleton"
import { EventCards } from "@/components/event-card/EventCard"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import ScheduleDetail from "@/components/event-card/ScheduleDetail"
import Calendar from "@/assets/icons/calendar.webp"
import Clock from "@/assets/icons/clock.webp"
import ScheduleBorder from "@/assets/imgs/cultural-event/schedule-border.webp"
import { formatDate3, formatTime2 } from "@/app/utils/helpers"
import SanitizedDescription from "@/components/SanitizedDescription"

const contentMApi = new ContentMAPI()

const Detail = () => {
  const { notifyError, pathname, setSeoContent } = useGlobalContext()
  const { slug } = useParams()
  const [blog, setBlog] = useState({})
  const [otherRecoms, setOtherRecoms] = useState([])
  const [onReq, setOnReq] = useState(true)
  const prefix = useRef("")
  const isFirstMount = useRef(true)

  useEffect(() => {
    fetchData()
    prefix.current = pathname.split("/")[1]

    return () => {
      setSeoContent(null)
    }
  }, [])

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false
      return
    }
    setSeoContent(null)
    fetchData()
  }, [slug])

  const fetchData = async () => {
    setOnReq(true)
    await loadBlogDetail()
    await loadOtherRecoms()
    setOnReq(false)
  }

  const displayDesc = (desc) => {
    return <SanitizedDescription desc={desc} id="blog-description" custCls="text-justify font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] my-5 lg:mt-10" />
  }

  // API request
  const loadBlogDetail = async () => {
    try {
      const { data } = await contentMApi.getBlogDetails(slug)
      console.log(data.data.description, 'data.data.description');

      setSeoContent({
        name: data.data.name,
        keywords: data.data.meta_keyword,
        description: data.data.meta_description,
        image: data.data.photo
      })
      const formattedDate = formatDate3(data.data.created_at);
      const formattedTime = formatTime2(data.data.created_at)
      const blogData = {
        ...data.data,
        published_date: formattedDate,
        published_time: formattedTime
      }
      setBlog(blogData)
    } catch (err) {
      notifyError(err.message)
    }
  }

  const loadOtherRecoms = async () => {
    try {
      const { data } = await contentMApi.getBlogRecoms(slug)
      setOtherRecoms(data.data)
    } catch (err) {
      notifyError(err.message)
    }
  }

  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <CenteredHero title={blog.name} custCls="bg-[url('/src/assets/imgs/cultural-event/banner.jpeg')] md:min-h-60 lg:min-h-96" />
        <section className="bg-[url('/src/assets/imgs/cultural-event/section-cover.webp')] px-10 md:px-12 lg:px-20 py-12">
          <div className="text-[#6d625a] font-light mb-10">
            <div className="flex flex-col lg:flex-row gap-6 sm:gap-x-10">
              <div className="w-full lg:w-[60%] text-center lg:text-left px-6 md:px-0">
                {onReq ?
                  <ContainerSkeleton custH="h-5 sm:h-8 xl:h-11" custW="w-full sm:w-[400px] md:w-[450px]" custCls="bg-cover mb-6 sm:mb-10 xl:mb-11" />
                  :
                  <div className="flex relative mb-5 sm:mb-9 xl:mb-10">
                    <img width="100" src={ScheduleBorder} className="w-[300px] sm:w-[400px] md:w-[450px]" />
                    <div className="absolute flex items-center gap-1.5 sm:gap-x-3 left-7">
                      <ScheduleDetail imgPath={Calendar} isFullDate
                        detail1={blog.published_date}
                      />
                      <div className="border border-separate border-[#9b894d] h-6 sm:h-8 md:h-9"></div>
                      <ScheduleDetail imgPath={Clock}
                        detail1={blog.published_time}
                      />
                    </div>
                  </div>
                }
                {onReq ?
                  <ContainerSkeleton custH="h-9 md:h-[60px] lg:h-[72px]" custCls="my-5 lg:mb-8 lg:mt-10" /> :
                  <h1 className="capitalize font-agcasmlt text-4xl md:text-6x lg:text-7xl">{blog.name}</h1>
                }

                {/* <div className="w-full h-full md:h-[500px] mt-5 overflow-hidden flex items-start justify-center">
                  {onReq ?
                    <ContainerSkeleton custCls="min-w-full min-h-full" />
                    :
                    <ImageSkeleton src={blog.photo} alt={blog.name} custCls="min-w-full min-h-full object-cover -mt-8" />
                  }
                </div> */}

                <div className="mt-5 block lg:hidden w-full">
                  {onReq ?
                    <div className="w-full h-[500px] overflow-hidden flex items-start justify-center">
                      <ContainerSkeleton custCls="min-w-full min-h-full" />
                    </div>
                    :
                    <div>
                      <ImageSkeleton src={blog.photo} alt={blog.name} custCls="w-full h-full object-cover" />
                    </div>
                  }
                </div>

                {onReq ?
                  <>
                    <ContainerSkeleton custH="h-[20px] md:h-[30px]" custCls="my-5 lg:mb-8 lg:mt-10" />
                    <ContainerSkeleton custH="h-[14px] sm:h-[18px] xl:h-5" />
                  </>
                  :
                  <>
                    {displayDesc(blog.description)}
                  </>
                }
              </div>


              <div className="hidden lg:block w-[40%]">
                {onReq ?
                  <div className="w-full h-[500px] overflow-hidden flex items-start justify-center">
                    <ContainerSkeleton custCls="min-w-full min-h-full -mt-8" />
                  </div>
                  :
                  <div>
                    <ImageSkeleton src={blog.photo} alt={blog.name} custCls="w-full h-full object-cover -mt-8" />
                  </div>
                }
              </div>
            </div>
            {/* } */}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 lg:gap-6 ">
          </div>
          <div className="pb-4">
            <EngraveTitle title="You May Also Like" />
            {onReq ? (
              otherRecoms.length <= 0 ?
                <EventCardSkeleton />
                :
                <EventCards events={otherRecoms} onReq={onReq} pathname={`/${prefix.current}`} />
            ) : (
              otherRecoms?.length > 0 ?
                <EventCards events={otherRecoms} onReq={onReq} pathname={`/${prefix.current}`} />
                :
                <p className="text-center text-gray-500">No recommendation available.</p>
            )}
          </div>
        </section>
      </GeneralLayout>
    </>
  )
}

export default Detail
